export const setHref = path => {
  window.location.href = path
}
